import { Component, OnInit } from '@angular/core';
import { ProfileSearchResult } from 'src/app/data/ProfileSearchResult';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ShipUserService } from 'src/app/services/ship-user.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-maintain-ship-user',
  templateUrl: './maintain-ship-user.component.html'
})
export class MaintainShipUserComponent implements OnInit {
  searchResults: ProfileSearchResult[];
  subview = '';
  search_btn = false;
  newSearchTerm = '';
  searchTerm = '';
  firstParameter = '';
  search_btn_spinner = '';
  cardholdersSearchForm: UntypedFormGroup;
  selectedCardNumber = '';

  constructor(
    private shipUserService: ShipUserService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.cardholdersSearchForm = new UntypedFormGroup({
      firstParameter: new UntypedFormControl('', {
        validators: [Validators.minLength(2), Validators.pattern(/^[0-9]{16}$/)]
      })
    });

    this.onChange();
  }

  onChange() {
    this.cardholdersSearchForm
      .get('firstParameter')
      .valueChanges.subscribe((search: string) => {
        this.firstParameter = search;
      });
  }

  showCardholder(cardholder: ProfileSearchResult) {
    this.selectedCardNumber = cardholder.cardNum;
    this.subview = 'cardholderSelected';
    this.firstParameter = '';
  }

  submitCardholderSearch() {
    this.searchResults = null;
    this.search_btn_spinner = 'fa fa-spinner fa-spin';
    this.search_btn = true;
    this.subview = 'results';
    if (this.firstParameter === undefined || this.firstParameter === '') {
      this.subview = 'noSearchParameters';
      this.search_btn_spinner = '';
      this.search_btn = false;
    } else {
      const useParameter = this.firstParameter;
      this.firstParameter = '';
      this.cardholdersSearchForm.get('firstParameter').reset();
      this.shipUserService.searchByCardPan(useParameter).subscribe(
        (data) => {
          if (data.length === 0) {
            this.subview = 'noResults';
          } else {
            this.searchResults = data;
            this.subview = 'results';
          }
          this.search_btn_spinner = '';
          this.search_btn = false;
        },
        () => {
          this.messageService.error(
            'There was a problem retrieving cardholder information'
          );
        },
        () => {
          const button = document.getElementById('searchButton');
          button.blur();
        }
      );
    }
  }

  userEntryClose() {
    this.subview = '';
    this.selectedCardNumber = '';
  }
}
